export default __webpack_public_path__ + "static/media/005-gas station.8acb3dcc.svg";